import React, { useCallback } from "react"
import i18nData from "@rogue_4/locales/zh-CN.json"
import { PropsWithStyle } from "@rogue_4/types"
import classNames from "classnames"

import { i18n } from "@/utils/i18n"

import styles from "./index.module.less"

const CircleButton = React.forwardRef<
    HTMLDivElement,
    PropsWithStyle<{
        type: "backpack" | "craft" | "fight" | "gallery"
        disabled?: boolean
        onClick?: (e: React.MouseEvent) => void
        propagation?: boolean
    }>
>(({ className, style, type, disabled, onClick, propagation }, ref) => {
    const handleClick = useCallback(
        (event: React.MouseEvent) => {
            if (onClick && !propagation) event.stopPropagation()
            onClick?.(event)
        },
        [onClick, propagation]
    )
    return (
        <div
            ref={ref}
            className={classNames(
                styles.circleButton,
                styles[type],
                disabled && styles.disabled,
                className
            )}
            style={style}
            onClick={handleClick}
        >
            <div className={styles.back}></div>
            <div className={styles.front}></div>
            <div className={styles.text}>
                <div
                    className={styles.cn}
                    data-text={i18n(i18nData, `rogue_4.game.button.cn.${type}`)}
                >
                    <span>
                        {i18n(i18nData, `rogue_4.game.button.cn.${type}`)}
                    </span>
                </div>
            </div>
        </div>
    )
})
CircleButton.displayName = "CircleButton"

export default CircleButton
